import * as R from 'ramda';

export const IssueDetailProducts = ({products}) => {
    return R.isEmpty(products) ? 'No Related Products' : products.map(({id, name}) => <div key={id}>{name}</div>);
};

const IssueDetailProductsDefault = IssueDetailProducts;

export default IssueDetailProductsDefault;
